import React, { useState } from "react";
import { showPromiseToast } from "../../services/toastService";
import { createReport } from "../../services/reportsService";
import LoadingSpinner from "../LoadingSpinner";

export default function ReportModal({ onClose }) {
	const [reportData, setReportData] = useState({
		text: "",
		phone: "",
		email: "",
		lat: null,
		lon: null,
	});
	const [loadingLocation, setLoadingLocation] = useState(false);

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setReportData((prev) => ({ ...prev, [name]: value }));
	};

	const handleGetLocation = () => {
		if (navigator.geolocation) {
			setLoadingLocation(true);
			navigator.geolocation.getCurrentPosition(
				(position) => {
					setReportData((prev) => ({
						...prev,
						lat: position.coords.latitude,
						lon: position.coords.longitude,
					}));
					setLoadingLocation(false);
				},
				() => {
					alert(
						"Impossibile ottenere la posizione. Assicurati che il GPS sia abilitato."
					);
					setLoadingLocation(false);
				}
			);
		} else {
			alert("La Geolocalizzazione non è supportata dal tuo browser.");
		}
	};

	const handleSubmit = () => {
		showPromiseToast(createReport(reportData), {
			pending: "Invio in corso...",
			success: "Segnalazione inviata con successo",
		}).then(() => onClose());
	};

	return (
		<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
			<div className="bg-white rounded-lg shadow-lg p-6 w-[600px]">
				<h2 className="text-lg font-bold mb-4 text-center">Invia una Segnalazione</h2>
				<div className="space-y-4">
					{/* Descrizione */}
					<div>
						<label className="block text-sm font-medium text-gray-700">
							Descrizione*
						</label>
						<textarea
							name="text"
							placeholder="Descrivi il problema"
							value={reportData.text}
							onChange={handleInputChange}
							className="w-full border border-gray-300 rounded-md p-2"
							required
						/>
					</div>

					{/* Telefono */}
					<div>
						<label className="block text-sm font-medium text-gray-700">Telefono</label>
						<input
							type="text"
							name="phone"
							placeholder="Numero di telefono (opzionale)"
							value={reportData.phone}
							onChange={handleInputChange}
							className="w-full border border-gray-300 rounded-md p-2"
						/>
					</div>

					{/* Email */}
					<div>
						<label className="block text-sm font-medium text-gray-700">Email</label>
						<input
							type="email"
							name="email"
							placeholder="Indirizzo email (opzionale)"
							value={reportData.email}
							onChange={handleInputChange}
							className="w-full border border-gray-300 rounded-md p-2"
						/>
					</div>

					{/* Pulsante Posizione */}
					<div>
						<button
							id="get-location"
							aria-label="Allega la tua posizione alla segnalazione"
							className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 transition flex items-center justify-center"
							onClick={handleGetLocation}
							disabled={loadingLocation}
						>
							{loadingLocation ? (
								<LoadingSpinner white size={20} />
							) : reportData.lat && reportData.lon ? (
								`Coordinate rilevate: ${reportData.lat}, ${reportData.lon}`
							) : (
								"Allega la tua posizione alla segnalazione"
							)}
						</button>
					</div>

					<div>
						<p className="text-md text-gray-600 mt-4 text-center">
							La tua segnalazione sarà valutata dal personale di Protezione Civile.
							<br />
							Se necessario, potresti ricevere un feedback tramite email o telefono
							per ulteriori dettagli.
						</p>
						<p className="text-sm text-gray-500 mt-2">
							Inviare la segnalazione implica l'accettazione della nostra{" "}
							<a
								href="/privacy-policy"
								target="_blank"
								rel="noopener noreferrer"
								className="text-blue-500 underline hover:text-blue-700"
							>
								Informativa sulla Privacy
							</a>
							.
						</p>
					</div>

					{/* Pulsanti */}
					<div className="flex justify-end space-x-4">
						<button
							id="cancel"
							aria-label="Annulla"
							className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
							onClick={onClose}
						>
							Annulla
						</button>
						<button
							id="submit"
							aria-label="Invia"
							className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
							onClick={handleSubmit}
						>
							Invia
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}
